/**
 * Test ID utilities for Calendar component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Calendar
 * @param identifier - Calendar identifier
 * @returns Test ID string
 */
export const setCalendarTestId = (identifier: string): string => generateTestId("Calendar", identifier.replace(/\s+/g, "-").toLowerCase());
